<template>
  <v-container fluid>
    <template v-if="message">
      <page-title icon="fas fa-fw fa-envelope">
        Email #{{ message.id }}
        <template v-slot:buttons>
          <v-chip color="success"
                  label>
            {{ message.status }}
          </v-chip>
        </template>
      </page-title>

      <AdminMessageCard :busy="busy"
                        :message="message"
                        :raw="raw">
      </AdminMessageCard>

    </template>
    <p v-else-if="busy"
       class="text-center">
      <v-progress-circular indeterminate
                           size="60">
      </v-progress-circular>
    </p>
  </v-container>
</template>
<script>
import PageTitle from '../../../components/PageTitle.vue';
import mailgunService from '../../../../../ml/services/mailgunService';
import MessageDateInfo from './components/MessageDateInfo.vue';
import AdminMessageCard from './components/AdminMessageCard.vue';

export default {
  components: {AdminMessageCard, MessageDateInfo, PageTitle},
  data() {
    return {
      busy: false,
      message: null,
      raw: null,
      webhooks: [],
      messageCardHeight: null,
    }
  },
  computed: {
    dataURI() {
      if (this.message && this.raw && this.raw.body) {
        return `/mailgun/messages/${this.message.id}/raw/body`;
      }
      return null;
    },
    fromAddress() {
      if (this.message.sender?.name) {
        return `${this.message.sender?.name} <${this.message.from_email}>`;
      }
      return this.message.from_address;
    },
    messageID() {
      return parseInt(this.$route.params.messageID);
    },
    messageCardStyle() {
      if (this.messageCardHeight) {
        return `height: ${this.messageCardHeight}px`;
      }
      return null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      try {
        await this.getMessage();
        await this.getRaw();
        await this.getWebhooks();
      } catch (err) {
        this.$toast.error('Message not found.');
        this.$router.back();
      } finally {
        this.busy = false;
      }
    },
    async getMessage() {
      return mailgunService.getMessage(this.messageID)
          .then(message => {
            this.message = message;
          })
    },
    async getRaw() {
      return mailgunService.getMessageRaw(this.messageID)
          .then(data => {
            this.raw = data;
          })
    },
    async getWebhooks() {
      return mailgunService.getWebhooks({message_id: this.message.message_id})
          .then(data => {
            this.webhooks = data.data;
          })
    },
    adjustCardHeight() {
      /*const messageCard = document.querySelector('.v-card.MessageCard');
      if (messageCard) {
        const scrollbarHeight = 22;
        const windowHeight = window.innerHeight;
        const cardTop = messageCard.getBoundingClientRect().top;
        console.log({windowHeight, cardTop, scrollbarHeight});
        this.messageCardHeight = windowHeight - cardTop - scrollbarHeight;
      }*/
    },
    resizeIFrame(event) {
      console.log(event.target);
      try {
        const iframe = event.target;
        const document = iframe.contentDocument || iframe.contentWindow.document;
        const height = document.documentElement.scrollHeight || document.body.scrollHeight;
        iframe.style.height = height + 'px';
      } catch (e) {
        console.log('Error resizing iframe: ', e);
      }
    }
  }
}
</script>
